export class WebCheckIn {
    public BookingId?: string;
    // public CheckInFlow: []
    public CheckInTime?: string;
    public CheckOutTime?: string;
    public City?: string;
    public Country?: string;
    public Email!: string;
    public EndDate?: Date;
    public EntryType!: string;
    public FirstName!: string;
    // public HotelColor: string;
    public HotelId?: string;
    public HotelName?: string;
    public HotelPhoneNumber?: string;
    public Image?: string;
    public IsPastStartDate?: boolean;
    public LastName!: string;
    public NumberOfAdults?: number;
    public NumberOfChildren?: number;
    public NumberOfRooms?: string;
    public PMSBookingNumber?: string;
    public PhoneNumber?: string;
    public ProductType?: string;
    public ReservationNumber?: string;
    public RoomType?: string;
    public StartDate?: Date;
    public Status?: string;
    public Id?: string;
    public StreetName?: string;
    public StreetNumber?: string;
    public UserId?: string;
    public ZipCode?: string;
}
